import styled from 'styled-components';
import { Button, Checkbox as CB } from 'junto-ui';

export const Wrapper = styled.div`
  padding: 56px 32px 48px 32px;
`;

export const Title = styled.h1`
  font-size: 20px;
  line-height: 26px;
  color: #180a33;
  margin-bottom: 16px;
  margin-top: 0px;
`;

export const ComplementaryText = styled.p`
  font-size: 16px;
  line-height: 22px;
  color: #180a33;
  margin-top: 0px;
  margin-bottom: 24px;
  font-weight: 300;
`;

export const Checkbox = styled(CB)`
  height: auto;

  & > label {
    align-self: start;
  }
`;

export const CheckboxLabel = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: #180a33;
  font-weight: 300;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const ConfirmButton = styled(Button)`
  margin-top: 24px;
  width: 312px;
  height: 64px;
`;
